import _colors from '../../../sass/_colors.scss';

export default _colors;
